<template>
	<div>
		<div>{{ row.institutionName }}</div>
		<div>ID: {{ row.institutionId }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
